import React from "react";
import GoogleMapReact from 'google-map-react';

import PropTypes from 'prop-types';

const CHICAGO_CENTER = { lat: 41.87716678688124, lng: -87.62801066068266 };
const apiKey = `AIzaSyCUwcsB0TTIJGrR2Tsth9nJn-3cpvm13oM`;

export default function SimpleMap({ locations }){
  const defaultProps = {
    zoom: 11
  };

  const markerPosition = locations ? locations.origin : CHICAGO_CENTER;

  return (
    <div style={{ height: '300px', width: '100%' }}>
      <GoogleMapReact
        bootstrapURLKeys={{ key: apiKey }}
        defaultCenter={markerPosition}
        defaultZoom={defaultProps.zoom}
        options={createMapOptions}
      >
        <Marker
          {...markerPosition}
          text="My Marker"
        />
      </GoogleMapReact>
    </div>
  );
};

function createMapOptions(maps) {
  // next props are exposed at maps
  // "Animation", "ControlPosition", "MapTypeControlStyle", "MapTypeId",
  // "NavigationControlStyle", "ScaleControlStyle", "StrokePosition", "SymbolPath", "ZoomControlStyle",
  // "DirectionsStatus", "DirectionsTravelMode", "DirectionsUnitSystem", "DistanceMatrixStatus",
  // "DistanceMatrixElementStatus", "ElevationStatus", "GeocoderLocationType", "GeocoderStatus", "KmlLayerStatus",
  // "MaxZoomStatus", "StreetViewStatus", "TransitMode", "TransitRoutePreference", "TravelMode", "UnitSystem"
  return {
    zoomControlOptions: {
      position: maps.ControlPosition.RIGHT_CENTER,
      style: maps.ZoomControlStyle.SMALL
    },
    mapTypeControlOptions: {
      position: maps.ControlPosition.TOP_RIGHT
    },
    mapTypeControl: true,
    StreetViewStatus: true,
    streetViewControl: true,
  };
}

// const Wrapper = styled.div`
//   position: absolute;
//   top: 50%;
//   left: 50%;
//   width: 18px;
//   height: 18px;
//   background-color: red;
//   border: 2px solid #fff;
//   border-radius: 100%;
//   user-select: none;
//   transform: translate(-50%, -50%);
//   cursor: ${(props) => (props.onClick ? 'pointer' : 'default')};
//   &:hover {
//     z-index: 1;
//   }
// `;

const Marker = ({ text, onClick }) => (
  <div
    style={{
    position: 'absolute',
    top: '50%',
    left: '50%',
    width: '18px',
    height: '18px',
    backgroundColor: 'red',
    border: '2px solid #fff',
    borderRadius: '100%',
    userSelect: 'none',
    transform: 'translate(-50%, -50%)',
    cursor: 'default',
   ' &:hover': {
      zIndex: 1,
    }
  }}
    alt={text}
    onClick={onClick}
  />
);

Marker.defaultProps = {
  onClick: null,
};

Marker.propTypes = {
  onClick: PropTypes.func,
  text: PropTypes.string.isRequired,
};
